import React, { useCallback, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { HeaderSpacer } from '../components/Header';
import ItemHeroPage from '../components/ItemHeroPage';
import { OutlinedButton, PageBackground } from '../components/common/hero/styles';
import { TEXT_DARK, TEXT_SECONDARY } from '../components/common/tokens';
import { getNamespacePath, selectContext, selectContextStatus } from '../redux/features/context/contextSlice';
import { fetchItem } from '../redux/features/items/itemsSlice';
import StyledBackdrop from '../components/StyledBackdrop';
import Login from '../components/Login';

export default function ItemReadView(props) {
  const { type: propType, namespace: propNamespace } = props;
  const type = propType || 'item';
  const { itemId } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.users);
  const status = useSelector(selectContextStatus);
  const currContext = useSelector(selectContext);

  const namespace = propNamespace || (userInfo ? 'private' : 'public');

  const loadItem = useCallback(
    () => dispatch(fetchItem({ namespace, itemId })),
    [dispatch, namespace, itemId],
  );

  useEffect(() => {
    loadItem();
  }, [loadItem]);

  let rawItem;
  let listInfos = [];
  let forceSignIn = false;
  let notFound = false;

  if (currContext?.type === type && currContext.item?.id === itemId) {
    rawItem = currContext.item;
    listInfos = currContext.listInfos || [];
  } else if (status !== 'loading' && currContext?.type === type && !currContext.item) {
    forceSignIn = true;
  } else if (status === 'failed') {
    if (userInfo) {
      notFound = true;
    } else {
      forceSignIn = true;
    }
  }

  const showSpinner = !forceSignIn && !notFound && !rawItem;

  return (
    <>
      <HeaderSpacer />
      {forceSignIn && <Login />}
      {notFound && (
        <PageBackground>
          <div style={{ textAlign: 'center', paddingTop: 48 }}>
            <h2 style={{ color: TEXT_DARK, fontWeight: 700, margin: '0 0 8px' }}>
              Item not found
            </h2>
            <p style={{ color: TEXT_SECONDARY, margin: '0 0 20px' }}>
              This item doesn&apos;t exist or is no longer available.
            </p>
            <OutlinedButton
              type="button"
              onClick={() => navigate(`/${getNamespacePath(namespace)}/items`)}
            >
              Browse items
            </OutlinedButton>
          </div>
        </PageBackground>
      )}
      {showSpinner && (
        <StyledBackdrop open>
          <CircularProgress color="inherit" />
        </StyledBackdrop>
      )}
      {!forceSignIn && !notFound && rawItem && (
        <ItemHeroPage
          item={rawItem}
          listInfos={listInfos}
          namespace={namespace}
          onRefetch={loadItem}
        />
      )}
    </>
  );
}
